// src/store/slices/authSlice.js
// ✅ sessionStorage au lieu de localStorage pour user + tokens
// ✅ isAnyOf supprimé (non utilisé)
import { createSlice } from "@reduxjs/toolkit";
import { clearTokens, getAccessToken, getRefreshToken, setTokens } from "../api/baseApi";

const USER_KEY = "__pm__user";

const loadUser = () => {
  try {
    // Migration : lire depuis les deux et préférer sessionStorage
    const ss = sessionStorage.getItem(USER_KEY);
    if (ss) return JSON.parse(ss);
    const ls = localStorage.getItem("user");
    if (ls) {
      // Migrer vers sessionStorage et supprimer de localStorage
      sessionStorage.setItem(USER_KEY, ls);
      localStorage.removeItem("user");
      return JSON.parse(ls);
    }
  } catch {}
  return null;
};

const saveUser = (user) => {
  if (user) sessionStorage.setItem(USER_KEY, JSON.stringify(user));
};

const removeUser = () => {
  sessionStorage.removeItem(USER_KEY);
  localStorage.removeItem("user"); // nettoyage migration
};

const initialState = {
  user: loadUser(),
  accessToken: getAccessToken(),
  refreshToken: getRefreshToken(),
  isAuthenticated: !!getAccessToken(),
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      state.accessToken = action.payload.accessToken;
      if (action.payload.refreshToken) state.refreshToken = action.payload.refreshToken;
      state.isAuthenticated = true;
    },
    setUser: (state, action) => {
      state.user = action.payload;
      state.isAuthenticated = true;
      if (action.payload) saveUser(action.payload);
    },
    logout: (state) => {
      state.user = null;
      state.accessToken = null;
      state.refreshToken = null;
      state.isAuthenticated = false;
      clearTokens();
      removeUser();
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      (action) => action.type === "api/executeMutation/fulfilled" && action.meta?.arg?.endpointName === "login",
      (state, action) => {
        const { access_token, refresh_token, user } = action.payload;
        if (access_token) {
          state.accessToken = access_token;
          state.refreshToken = refresh_token;
          state.isAuthenticated = true;
          setTokens(access_token, refresh_token);
        }
        if (user) { state.user = user; saveUser(user); }
      }
    );
    builder.addMatcher(
      (action) => action.type === "api/executeQuery/fulfilled" && action.meta?.arg?.endpointName === "getProfileCoach",
      (state, action) => {
        state.user = action.payload;
        state.isAuthenticated = true;
        saveUser(action.payload);
      }
    );
    builder.addMatcher(
      (action) => action.type === "api/executeMutation/fulfilled" && action.meta?.arg?.endpointName === "logout",
      (state) => {
        state.user = null; state.accessToken = null; state.refreshToken = null;
        state.isAuthenticated = false; clearTokens(); removeUser();
      }
    );
  },
});

export const { setCredentials, setUser, logout } = authSlice.actions;
export default authSlice.reducer;
export const selectCurrentUser     = (state) => state.auth.user;
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;
export const selectAccessToken     = (state) => state.auth.accessToken;